import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { fetchItems } from "../../actions/propertyActions";
import {
  makePropertyOptionsSelector,
  makePropertyOptionsAnyKeySelector,
  makePropertyOptionsFetchStatusSelector,
} from "../../selectors/propertyOptions";
import { PROPERTY_OPTION_SHAPE } from "../../constants/propertyConstants";
import { COLLECTION_FETCH_STATUS_SHAPE } from "../../selectors/collections";
import LoadableCollection from "../../components/ui/loadable/collection";


export function withPropertyOptions(WrappedComponent) {

  const WithPropertyOptions = class extends Component {

    componentDidMount() {
      this.fetchProperties();
    }

    shouldComponentUpdate(prevProps) {
      if (prevProps.fetchStatus && prevProps.fetchStatus.isFetching) {
        return false
      } else {
        return true
      }
    }

    fetchProperties = (currentPage = 1) => {
      const { fetchItems, fetchStatus } = this.props;

      if (!fetchStatus.isFetching) {
        fetchItems(currentPage);
      }
    };

    render() {
      const { propertyOptions, pagination, fetchStatus, children, ...restProps } = this.props;

      return (
        <LoadableCollection fetchStatus={fetchStatus}>
          {
            () => <WrappedComponent
                    {...restProps}
                    propertyOptions={propertyOptions}
                    pagination={pagination}
                    fetchStatus={fetchStatus}
                    fetchProperties={this.fetchProperties}
                  />
          }
        </LoadableCollection>
      )
    }
  };

  WithPropertyOptions.propTypes = {
    propertyOptions: PropTypes.arrayOf(PropTypes.shape(PROPERTY_OPTION_SHAPE)),
    fetchStatus: PropTypes.shape(COLLECTION_FETCH_STATUS_SHAPE).isRequired,
  };

  const propertyOptionsSelector = makePropertyOptionsSelector();
  const propertyOptionsPaginationSelector = makePropertyOptionsAnyKeySelector('pagination');
  const propertyOptionsFetchStatusSelector = makePropertyOptionsFetchStatusSelector();

  function mapStateToProps(state) {
    return {
      propertyOptions: propertyOptionsSelector(state),
      pagination: propertyOptionsPaginationSelector(state) || {},
      fetchStatus: propertyOptionsFetchStatusSelector(state),
    }
  }

  function mapDispatchToProps(dispatch) {
    return bindActionCreators({
      fetchItems,
    }, dispatch)
  }

  return connect(mapStateToProps, mapDispatchToProps)(WithPropertyOptions);
}